<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const addStat = () => {
  props.block.data.stats = [...(props.block.data.stats ?? []), { value: '', label: '' }]
}
const removeStat = (i: number) => {
  props.block.data.stats?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <SiteEditorArrayItemCard
    v-for="(stat, i) in block.data.stats ?? []"
    :key="i"
    :label="`${t('site.f.stats.item_label', 'Stat')} ${i + 1}`"
    @remove="removeStat(i)"
  >
    <UInput
      v-model="stat.value"
      :placeholder="t('site.f.stats.value', 'Value (e.g. 18)')"
      class="w-full"
    />
    <UInput
      v-model="stat.label"
      :placeholder="t('site.f.stats.label', 'Label (e.g. Years)')"
      class="w-full"
    />
  </SiteEditorArrayItemCard>
  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addStat"
  >
    {{ t('site.f.stats.add_item', 'Add stat') }}
  </UButton>
</template>
